"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupOnboardingConfirmationRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.GroupOnboardingConfirmationRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.group_onboarding_confirmation.label',
    fallbackLabel: 'Group onboarding confirmation',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'SAME_ANSWERS_FOR_ALL_COMPANIES', label: 'fields.enm.group_onboarding_confirmation.options.SAME_ANSWERS_FOR_ALL_COMPANIES', fallbackLabel: 'I confirm that all these answers are the same for all companies from the group' },
        { key: 'DIFFERENCES_BETWEEN_COMPANIES', label: 'fields.enm.group_onboarding_confirmation.options.DIFFERENCES_BETWEEN_COMPANIES', fallbackLabel: 'There are some differences between the companies from the group' },
        { key: 'NO_GROUP_ONBOARDING', label: 'fields.enm.group_onboarding_confirmation.options.NO_GROUP_ONBOARDING', fallbackLabel: 'Not applicable (responses provided solely for a single company; no group onboarding involved)' },
    ],
    trackFieldValueWithAnalytics: false,
};
